import { z } from 'zod';

export const ApplicationModeSchema = z.union([
    z.literal('Demo'),
    z.literal('Freemium'),
    z.literal('Paid'),
    z.literal(''),
]);

export const CapabilitySchema = z.record(
    z.string().startsWith('cp_'),
    z.boolean(),
);

export const ApplicationPayloadSchema = z.object({
    application_mode: ApplicationModeSchema,
    application_version: z.string(),
    dat_primary_application: z.string(),
    tracking_version: z.string(),
    traits: z.any().optional()
});
export const UserInfoSchema = z.object({
    name: z.string().optional(),
    user_id: z.string().optional(),
    csb_user_id: z.number().optional(),
});
export const IndentifyTrackingSchema = z.union([
    CapabilitySchema,
    ApplicationPayloadSchema.merge(UserInfoSchema),
]);
export const ApplicationInfoSchema =
    ApplicationPayloadSchema.merge(UserInfoSchema);
export const RegisterPayloadSchema = z.object({
    type: z.literal('SEGMENT'),
    events: z.array(z.any()),
    appInfo: ApplicationPayloadSchema,
});

export const TrackingEventTypeSchema = z.union([
    z.literal('PAGE'),
    z.literal('TRACK'),
    z.literal('IDENTIFY'),
    z.literal('RESET'),
]);

export const TrackingEventSchema = z.object({
    type: z.literal('SEGMENT'),
    eventType: TrackingEventTypeSchema,
    interaction: z.string(),
    eventName: z.string(),
    props: z.record(z.string(), z.string()),
});

export type EventRow = {
    'Change Type'?: string;
    'Event Name'?: string;
    'Global ID'?: number;
    ID?: number;
    Initiator?: string;
    Location?: string;
    Page?: string;
    'Pre- Implementation Status'?: string;
    Priority?: null;
    'Specific Properties'?: string;
    Status?: null;
    Ticket?: null;
    'Tracking Type'?: string;
};

export type RegisterPayload = z.infer<typeof RegisterPayloadSchema>;
export type ApplicationInfo = z.infer<typeof ApplicationInfoSchema>;
export type Capabilities = z.infer<typeof CapabilitySchema>;
export type UserInfo = z.infer<typeof UserInfoSchema>;
export type ApplicationPayload = z.infer<typeof ApplicationPayloadSchema>;
export type IdentifyTracking = z.infer<typeof IndentifyTrackingSchema>;
export type TrackingEvent = z.infer<typeof TrackingEventSchema>;
